import { makeStyles } from '@material-ui/core';

const useDelaStarIconStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(-2, 0, 0.5, 0),
    fill: theme.palette.Dela.darkIcon,
    fontSize: theme.spacing(2)
  }
}));

export default useDelaStarIconStyles;
